<button class="floating-button" [style.bottom.px]="styleBottom" (click)="action()">{{ buttonLabel }}</button>
